import {Utilities} from '@shared/utilities/utilities.model';
import {WorkingTypes} from './enums.model';
import {AuthorityAttachment} from './attachment.model';
import {RepairWorkingModel} from './repair-working.model';
import {PracticeModel} from './practice-model';
import { DossierTotal } from './dossier.model';
import { CarBodyQuotationDetail, MechanicQuotationDetail } from './quotation-details.model';
import { logger } from '@app/shared/utilities/logger.model';

export class WorkingModel {
	causalType: string = null;
	endDate: string = null;
	id: string = null;
	startDate: string = null;
	status: string = null;
	type: WorkingTypes;
	practicesIds: string[] = [];
	claimsList: ClaimItemModel[] = [];
	repairsList: RepairWorkingModel[] = [];
	practicesList: PracticeModel[] = [];
	workingItems: string[] = [];
	poDetails: PoDetailsModel[] = [];
	//  franchiseNumber: string = null;
	attachments: AuthorityAttachment[];
	working_number: string;
	working_number_prefix: string;
	actions: {
		can_be_deleted: boolean
		can_be_edited: boolean
	};
	franchiseNumber: string;

	isOnerous: boolean;
	isWreck: boolean;
	dossierWorkingQualification: string;
	rulesId: string;
	isRepair: boolean;
	isPractices: boolean;
	commodity_id: string;
	userGroup: string;
	userName: string;
	isAutomaticAuthorization: boolean;
	pre_authority_rules?: PreAuthorityRule[];
	aldCommodityId: string;
	firstApprovedAt: string;
	lastApprovedAt: string;
	created_at: string;
	total?: DossierTotal;
	archived: boolean;

	private quotation? : MechanicQuotationDetail | CarBodyQuotationDetail;
	cluster: string;
	cluster_description: string;

	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {

			// quando viene passata un oggetto già istanziato
			// in passato veniva utilizzata l'assegnazione nativa
			// andrebbe aggiornato il codice istanziando sempre la classe
			if (model instanceof WorkingModel) {
				model = this.object2DTO(model);
			}

			this.id = model.id;
			this.causalType = model.causal_type;
			this.endDate = model.end_date;
			this.startDate = model.start_date;
			this.status = model.status;
			this.type = model.type;
			this.claimsList = [];
			this.repairsList = [];
			this.practicesList = [];

			if (model.claims_list) {
				model.claims_list.forEach(el => {
					const claim: ClaimItemModel = new ClaimItemModel(el);
					this.claimsList.push(claim);
				});
			}
			if (model.repairs_list) {
				model.repairs_list.forEach(el1 => {
					const repair: RepairWorkingModel = new RepairWorkingModel(el1);
					this.repairsList.push(repair);
				});
			}
			if (model.car_practice_list) {
				model.car_practice_list.forEach(el2 => {
					const practice: PracticeModel = new PracticeModel(el2);
					this.practicesList.push(practice);
				});
			}
			this.practicesIds = model.practices_ids || [];
			this.workingItems = model.working_items || [];
			
			if (model.po_details) {
				model.po_details.forEach(el => {
					const poDetail: PoDetailsModel = new PoDetailsModel(el);
					this.poDetails.push(poDetail);
				});
			}
			this.franchiseNumber = model.franchise_number;
			this.attachments = [];
			this.working_number = model.working_number;
			this.working_number_prefix = model.working_number_prefix;
			this.commodity_id = model.commodity_id;
			this.userGroup = model.user_group;
			this.userName = model.user_name;
			if (!Utilities.isVoid(model.attachments)) {
				model.attachments.forEach(attachment => this.attachments.push(new AuthorityAttachment(attachment)));
				//this.claimsList = model.claims_list || [];
				this.actions = model.actions;
				this.isOnerous = model.is_onerous;
				this.isWreck = model.is_wreck;
				this.dossierWorkingQualification = model.dossier_working_qualification;
			}
			this.isAutomaticAuthorization = model.is_automatic_authorization;
			this.pre_authority_rules = model.pre_authority_rules;
			this.aldCommodityId = model.ald_commodity_id;
			this.firstApprovedAt = model.first_approved_at;
			this.lastApprovedAt = model.last_approved_at;
			this.created_at = model.created_at;
			this.total = model.total;
			this.quotation = model.quotation;
			this.cluster = model.cluster;
			this.cluster_description = model.cluster_description;
			this.archived = model.archived;
		}
	}
	
	setArchived(archived: boolean): void {
		this.archived = archived;
	}
	
	/**
	 * Indica se la pratica è chiusa-archiviato
	 * La pratica archiviata non può essere canalizzata
	 * 
	 * @returns {boolean}
	 */
	isArchived(): boolean {
		// return true;
		return !!this.archived;
	}

	getQuotation(): MechanicQuotationDetail | CarBodyQuotationDetail {
		return this.quotation;
	}

	setQuotation(quotation: MechanicQuotationDetail | CarBodyQuotationDetail): void {
		this.quotation = quotation;
	}

	/**
	 * Converte un oggetto pratica in un DTO
	 * @param {WorkingModel} working
	 * @returns {any}
	 */ 
	object2DTO(working: WorkingModel): any {

		const quotation: MechanicQuotationDetail | CarBodyQuotationDetail = Utilities.nullish(working.getQuotation(), null);

		const getQuotationDTO = (quotation: MechanicQuotationDetail | CarBodyQuotationDetail) => {
			// non ha senso, ma dava errore scrivendo così
			// quotation: quotation.object2DTO(quotation),
			// dato che non è stata usata la OOP correttamente...
			return (quotation instanceof MechanicQuotationDetail) ? quotation.object2DTO(quotation) : quotation.object2DTO(quotation);
		};
		
		return {
			id 												    : working.id,
			causal_type 							    : working.causalType,
			end_date 									    : working.endDate,
			start_date 								    : working.startDate,
			status 										    : working.status,
			type 											    : working.type,
			practices_ids 						    : working.practicesIds,
			working_items 						    : working.workingItems,
			franchise_number 					    : working.franchiseNumber,
			working_number 						    : working.working_number,
			working_number_prefix 		    : working.working_number_prefix,
			commodity_id 							    : working.commodity_id,
			user_group 								    : working.userGroup,
			user_name 								    : working.userName,
			is_automatic_authorization    : working.isAutomaticAuthorization,
			ald_commodity_id 					    : working.aldCommodityId,
			first_approved_at 				    : working.firstApprovedAt,
			last_approved_at 					    : working.lastApprovedAt,
			created_at 								    : working.created_at,
			total 										    : working.total,
			actions 											: working.actions,
			is_onerous 										: working.isOnerous,
			is_wreck 											: working.isWreck,
			dossier_working_qualification : working.dossierWorkingQualification,			
			pre_authority_rules 			    : working.pre_authority_rules,

			// da mettere nella classe PoDetailsModel
			po_details : Utilities.isEmpty(working.poDetails) ? [] : working.poDetails.map((x: PoDetailsModel) => {
				return {
					commodity_name : x.commodityName,
					po						 : x.po,
					po_amount			 : x.poAmount,
					operation			 : x.operation,
				};
			}),
			
			// da mettere nella classe ClaimItemModel
			claims_list : Utilities.isEmpty(working.claimsList) ? [] : working.claimsList.map((x: ClaimItemModel) => {
				return {
					claim_id 					: x.claim_id,
					franchise_number 	: x.franchise_number,
					practice_id 			: x.practice_id,
				};
			}),

			// da mettere nella classe RepairWorkingModel
			repairs_list : Utilities.isEmpty(working.repairsList) ? [] : working.repairsList.map((x: RepairWorkingModel) => {
				return {
					id												: x.id,
					practice_id								: x.practice_id,
					created_at								: x.created_at,
					claim_practice_id					: x.claim_practice_id,
					status										: x.status,
					authority_practice_linked	: x.authority_practice_linked,
				};
			}),
			
			// da mettere nella classe PracticeModel
			car_practice_list : Utilities.isEmpty(working.practicesList) ? [] : working.practicesList.map((x: PracticeModel) => {
				return {
					created_at 		   : x.created_at,
					id 						   : x.id,
					practice_id 	   : x.practice_id,
					plate 				   : x.plate,
					practice_type    : x.practice_type,
					status 				   : x.status,
					processing_types : !Utilities.isEmpty(x.processing_types) ? x.processing_types : [],
				};
			}),
			
			// da mettere nella classe AuthorityAttachment
			attachments: Utilities.isEmpty(working.attachments) ? [] : working.attachments.map((x: AuthorityAttachment) => {
				return {
					blob_name 			: x.blobName,
					blob_type 			: x.blobType,
					description 		: x.description,
					file_name 			: x.fileName,
					file_size 			: x.fileSize,
					mime_type 			: x.mimeType,
					resource_id 		: x.resourceId,
					resource_type 	: x.resourceType,
					status 					: x.status,
					thumbnail_id 		: x.thumbnailId,
					uuid 						: x.uuid,
					user_first_name : x.userFirstName,
					user_last_name 	: x.userLastName,
					created_at 			: x.createdAt,
				}
			}),
			
			quotation: Utilities.isEmpty(quotation) ? null : getQuotationDTO(quotation),
		};
	}
}

export class ClaimItemModel {
	claim_id: string;
	franchise_number: string;
	practice_id: string;

	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			this.claim_id = model.claim_id;
			this.franchise_number = model.franchise_number;
			this.practice_id = model.practice_id;
		}
	}
}

export class PoDetailsModel {
	commodityName: string;
	po: string;
	poAmount: number;
	operation: keyof typeof operationType;

	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			this.commodityName = model.commodity_name;
			this.po = model.po;
			this.poAmount = model.po_amount;
			this.operation = model.operation;
		}
	}
}

export enum operationType {
	INTEGRATION = 'INTEGRATION',
	REMOVING = 'REMOVING',
	CANCELED = 'CANCELED',
}

export interface PreAuthorityRule {
	pre_authority_status: string;
	rules_details: RuleDetail[];
}

export interface RuleDetail {
	id: string;
	value: string;
	name: string;
	description: string;
}

export enum ERejectionType {
	WRECK =      'WRECK',
	SUSPENSION = 'SUSPENSION',
	OTHER =      'OTHER',
}

/**
 * 	REGOLE DI DISSOCIABILITà
 *  La logica è implementata lato BE
 * 
 * 	La dissociabilità di una pratica di riparazione è una informazione che Claims fornisce ad Authority su richiesta di Authority.
 * 	La dissociabilità è data dalla combinazione di 2 fattori: flag di dissociabilità e dallo stato della pratica.
 * 
 * 	Il valore di default del flag è “false”
 * 
 * 		1)	Rifiuto definitivo motivazione “wreck”. Claims riceve un aggiornamento della pratica con le informazioni di “rifiuto definitivo” con motivazione “wreck”. Si hanno i seguenti casi:
 * 			a.	Flag di dissociabilità=”false” la pratica non è dissociabile e Claims risponde ad Authority che la pratica non è dissociabile.
 * 			b.	Flag di dissociabilità=”true” la pratica è dissociabile e Claims risponde ad Authority che la pratica è dissociabile.
 * 
 * 		2)	Rifiuto definitivo motivazione “scaduto”. Claims riceve un aggiornamento della pratica con le informazioni di “rifiuto definitivo” con motivazione “scaduto”. Si hanno i seguenti casi:
 * 			a.	Flag di dissociabilità=”false” la pratica non è dissociabile e Claims risponde ad Authority che la pratica non è dissociabile.
 * 			b.	Flag di dissociabilità=”true” la pratica è dissociabile e Claims risponde ad Authority che la pratica è dissociabile.
 * 
 * 		3)	Rifiuto definitivo motivazione “altro”. Claims riceve un aggiornamento della pratica con le informazioni di “rifiuto definitivo” con motivazione “altro”. Si hanno i seguenti casi:
 * 				a.	Flag di dissociabilità=”false”. È necessario verificare in Claims se la pratica al momento associata, ha avuto in precedenza un rifiuto definitivo per wreck o scaduto. In questo caso la pratica non è dissociabile e Claims risponde ad Authority che la pratica non è dissociabile.
 * 						Se la pratica al momento associata non ha avuto in precedenza un rifiuto definitivo per wreck o scaduto, la pratica è dissociabile e Claims risponde ad Authority che la pratica è dissociabile,
 * 				b.	Flag di dissociabilità=”true” la pratica è dissociabile e Claims risponde ad Authority che la pratica è dissociabile.
 * 
 */ 
export class RespWorkingDissociable {
	dossier_number: string;
	is_dissociable: boolean;
	working_number: string;

	constructor(obj?: any) {

		if (!Utilities.isEmpty(obj)) {
			Object.assign(this, obj);
		}
	}
}
